import { ROLE_HIERARCHY_LEVEL, RoleCode } from "../role.constants";

const ROLE_CODE_SET = new Set<string>(Object.values(RoleCode));

export function isRoleCode(code: string): code is RoleCode {
  return ROLE_CODE_SET.has(code);
}

export function toKnownRoleCodes(codes: string[]): RoleCode[] {
  return codes.filter(isRoleCode);
}

export function getTheHighestRole(roles: RoleCode[]): RoleCode {
  return roles.reduce((highest, role) =>
    ROLE_HIERARCHY_LEVEL[role] < ROLE_HIERARCHY_LEVEL[highest] ? role : highest,
  );
}
